(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article-magazine"]) return;
  try {
    
  (function () {
    function initMagLightbox() {
      var items = Array.prototype.slice.call(document.querySelectorAll('.mag-gallery__item'));
      if (!items.length) return;

      var urls = items.map(function (el) { return el.getAttribute('data-full'); });
      var current = 0;

      var lb = document.createElement('div');
      lb.className = 'mag-lb';
      lb.innerHTML =
        '<button class="mag-lb__btn mag-lb__close" aria-label="Fermer">&times;</button>' +
        '<button class="mag-lb__btn mag-lb__prev" aria-label="Precedent">&#8249;</button>' +
        '<button class="mag-lb__btn mag-lb__next" aria-label="Suivant">&#8250;</button>' +
        '<img alt="">';
      document.body.appendChild(lb);

      var img = lb.querySelector('img');

      function show(i) {
        current = (i + urls.length) % urls.length;
        img.src = urls[current];
        lb.classList.add('is-open');
      }
      function close() { lb.classList.remove('is-open'); }

      items.forEach(function (el, i) {
        el.addEventListener('click', function () { show(i); });
      });
      lb.querySelector('.mag-lb__close').addEventListener('click', close);
      lb.querySelector('.mag-lb__prev').addEventListener('click', function (e) { e.stopPropagation(); show(current - 1); });
      lb.querySelector('.mag-lb__next').addEventListener('click', function (e) { e.stopPropagation(); show(current + 1); });
      lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
      document.addEventListener('keydown', function (e) {
        if (!lb.classList.contains('is-open')) return;
        if (e.key === 'Escape') close();
        if (e.key === 'ArrowLeft') show(current - 1);
        if (e.key === 'ArrowRight') show(current + 1);
      });
    }

    function initMagToc() {
      var box = document.getElementById('mag-toc');
      var list = document.getElementById('mag-toc-list');
      if (!box || !list) return;

      var body = document.querySelector('.mag__body');
      if (!body) return;

      var headings = Array.prototype.slice.call(body.querySelectorAll('h2'));
      if (!headings.length) return;

      headings.forEach(function (h, i) {
        if (!h.id) h.id = 'mag-section-' + (i + 1);
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent.replace(/[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}]/gu, '').trim();
        var li = document.createElement('li');
        li.appendChild(a);
        list.appendChild(li);
      });

      box.hidden = false;

      var links = Array.prototype.slice.call(list.querySelectorAll('a'));
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var link = list.querySelector('a[href="#' + entry.target.id + '"]');
            if (!link) return;
            if (entry.isIntersecting) {
              links.forEach(function (l) { l.classList.remove('is-active'); });
              link.classList.add('is-active');
            }
          });
        }, { rootMargin: '-20% 0px -70% 0px' });
        headings.forEach(function (h) { observer.observe(h); });
      }
    }

    function initMag() {
      initMagLightbox();
      initMagToc();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initMag);
    } else {
      initMag();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
